if (!customElements.get('form-popup')) {
  class FormPopup extends HTMLElement {
    static OPEN_CLASS = 'is-open';

    constructor() {
      super();

      this.handleToggleRef = this.handleToggle.bind(this);
    }

    handleToggle() {
      this.classList.toggle(FormPopup.OPEN_CLASS);

      this.classList.contains(FormPopup.OPEN_CLASS)
        ? bodyScroll.lock(this.querySelector('[js-inner]'))
        : bodyScroll.clear();
    }

    disconnectedCallback() {
      document.removeEventListener('form-popup:toggle', this.handleToggleRef);
    }

    connectedCallback() {
      document.addEventListener('form-popup:toggle', this.handleToggleRef);
    }
  }

  customElements.define('form-popup', FormPopup);
}
